import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Hero from './components/Hero';
import Operations from './components/Operations';
import Offerings from './components/Offerings';

import Differentiators from './components/Differentiators';
import Services from './components/Services';
import InvestmentSectors from './components/InvestmentSectors';
import About from './components/About';
import Stats from './components/Stats';
import InvestmentCalculator from './components/InvestmentCalculator';
import Contact from './components/Contact';
import Footer from './components/Footer';

// New page components
import ServicesPage from './components/pages/ServicesPage';
import AboutPage from './components/pages/AboutPage';
import BlockchainPage from './components/pages/BlockchainPage';
import RealEstatePage from './components/pages/RealEstatePage';
import IndicesPage from './components/pages/IndicesPage';
import StocksPage from './components/pages/StocksPage';
import CompoundingPlansPage from './components/pages/CompoundingPlansPage';
import FAQPage from './components/pages/FAQPage';
import PrivacyPolicyPage from './components/pages/PrivacyPolicyPage';
import TermsOfServicePage from './components/pages/TermsOfServicePage';

import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App min-h-screen bg-white">
        <Header />
        <Routes>
          {/* Home page */}
          <Route path="/" element={
            <main className="animate-fade-in">
              <Hero />
              <About />
              {/* <Operations /> */}
              <Offerings />
              <Differentiators />
              {/* <Services /> */}
              <InvestmentSectors />
              <Stats />
              {/* <InvestmentCalculator /> */}
            </main>
          } />
          
          {/* Main pages */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQPage />} />
          
          {/* Sectors */}
          <Route path="/sectors/blockchain" element={<BlockchainPage />} />
          <Route path="/sectors/gold" element={<BlockchainPage />} />
          <Route path="/sectors/cryptocurrency" element={<BlockchainPage />} />
          <Route path="/sectors/real-estate" element={<RealEstatePage />} />
          <Route path="/sectors/indices" element={<IndicesPage />} />
          <Route path="/sectors/stocks" element={<StocksPage />} />
          
          {/* Plans */}
          <Route path="/plans/compounding" element={<CompoundingPlansPage />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
